module.exports = __webpack_public_path__ + "img/korea.fdf24a13.svg";